import { isPlatformBrowser } from "@angular/common";
import { Injectable, PLATFORM_ID, inject } from "@angular/core";
import { Observable } from "rxjs";
import { Socket } from "socket.io-client";
import { io } from "socket.io-client";

export enum SocketEvents {
  NEW_CONVERSATION = 'NEW_CONVERSATION',
  REMOVE_CONVERSATION = 'REMOVE_CONVERSATION',
  NEW_SCREENING_CYCLE = 'NEW_SCREENING_CYCLE',
  SCREENING_CYCLE_UPDATED = 'SCREENING_CYCLE_UPDATED',
  
  NEW_TREATMENT = 'NEW_TREATMENT',
  REMOVE_TREATMENT = "REMOVE_TREATMENT",
  ALTER_TREATMENT = "ALTER_TREATMENT",

  NEW_ALERTS = 'NEW_ALERTS',
  
  PROF_DASHBOARD_INTERACTION = 'PROF_DASHBOARD_INTERACTION',

  NEW_PROFESSIONAL = 'NEW_PROFESSIONAL',

  NEW_MOLECULE = 'NEW_MOLECULE',

  LATENCY = 'LATENCY',

  POINTS_AWARDED = 'POINTS_AWARDED',
}

export interface SocketEvent {
  socket_type: SocketEvents;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class SocketIoService {
  private socket: Socket | null = null;
  private platformId = inject(PLATFORM_ID);
  private pendingEvents: Array<{ event: string; data: any }> = [];

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeSocket();
    }
  }

  private initializeSocket() {
    this.socket = io('https://drazamed.com', {
      transports: ['websocket'],
      path: '/rest/socket.io',
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });

    this.socket.on('connect', () => {
      console.log('Socket connected');

      // Re-enviar solo una vez, justo aquí.
      for (const { event, data } of this.pendingEvents) {
        this.socket!.emit(event, data);
      }

      this.pendingEvents = [];
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }

  emit(event: string, data: any) {
    if (!this.socket) {
      this.pendingEvents.push({ event, data });
      return;
    }

    if (this.socket.connected) {
      this.socket.emit(event, data);
    } else {
      this.pendingEvents.push({ event, data });
    }
  }

  listen(socketType: SocketEvents): Observable<SocketEvent> {
    return new Observable((subscriber) => {
      if (!this.socket) return;

      this.socket.on(socketType, (data: SocketEvent) => {
        subscriber.next(data);
      });

      return () => {
        this.socket?.off(socketType);
      };
    });
  }
}